const { showErrorMessage } = require('../../functions')
$(() => {
    const csrf = {
        [$('meta[name="csrf-param"]').attr('content')]: $('meta[name="csrf-token"]').attr('content')
    }

    const status = $('#stripeCheckoutStatus')
    if (status.length) {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = urlParams.get('session_id');

        if (sessionId) {
            function checkSession() {
                $.post('/stripe/verification/', {sessionId, ...csrf}, (response) => {
                    if (response.order) {
                        window.location.href = '/checkout/receipt/?order=' + response.order;
                        return;
                    }

                    setTimeout(checkSession, 5000);
                })
            }


            setTimeout(checkSession, 5000);
        }
    }


    if (!window.Stripe || !window.STRIPE_PUBLIC_KEY) {
        return
    }

    const stripe = new Stripe(STRIPE_PUBLIC_KEY)
    const loader = $('.request-process-status')


    $(document).on('click', '#js-stripe-button', function () {
        const confirmation = $('#js-confirm')
        if (confirmation.length && !confirmation.is(':checked')) {
            return showErrorMessage('Please confirm the terms and conditions');
        }

        loader.show()
        $.post('/stripe/session/', csrf, (response) => {
            if (response.error) {
                return showErrorMessage(response.error)
            }

            if (response.id) {
                return stripe.redirectToCheckout({sessionId: response.id})
            }
        }).always(() => loader.hide())
    })
})